import React, { useState, useEffect, useRef } from "react";
import { FaBars, FaTimes, FaSignInAlt } from "react-icons/fa";
import loginIcon from "../../assets/icons/login-icon.svg";
import logo from "../../assets/images/logo.svg";
import Button from "../ui/Button";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const mobileMenuRef = useRef(null);
  const navLinks = ["How It Works", "About", "Contact"];

  // Close menu on outside click
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.body.style.overflow = "hidden"; // prevent scroll
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen]);

  return (
    <nav className="bg-white shadow-md fixed w-full z-50">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <img src={logo} alt="AgroLink" className="h-8" />
        </div>

        {/* Desktop Links (centered via absolute positioning) */}
        <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 items-center space-x-14">
          {navLinks.map((link) => (
            <a
              key={link}
              href={`#${link.replace(/\s+/g, "").toLowerCase()}`}
              className="text-gray-700 hover:text-green-700 font-medium"
            >
              {link}
            </a>
          ))}
        </div>

        {/* Right Section (login + button) */}
        <div className="hidden md:flex items-center gap-10">
          <div className="flex items-center gap-1 text-green-900 font-semibold">
            <img src={loginIcon} alt="login-icon" className="h-8" />
            <Link to="/signin">
              <button>Login</button>
            </Link>
          </div>

          <Link to="/signup">
            <Button className="rounded-full px-10">Get Started</Button>
          </Link>
        </div>

        {/* Mobile Toggle */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(true)}>
            <FaBars className="text-2xl text-green-800" />
          </button>
        </div>
      </div>

      {/* Blur Overlay on mobile */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-30 z-30 transition-opacity" />
      )}

      {/* Mobile Menu */}
      <div
        ref={mobileMenuRef}
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg z-40 transform transition-transform duration-300 ease-in-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="font-bold text-lg">Menu</h2>
          <FaTimes
            className="text-xl cursor-pointer"
            onClick={() => setIsOpen(false)}
          />
        </div>
        <div className="flex flex-col p-4 space-y-4">
          {navLinks.map((link) => (
            <a
              key={link}
              href={`#${link.replace(/\s+/g, "").toLowerCase()}`}
              className="text-gray-700 hover:text-green-700 font-medium"
              onClick={() => setIsOpen(false)}
            >
              {link}
            </a>
          ))}
          <div className="flex items-center gap-2 text-green-900 font-semibold mt-4">
            <FaSignInAlt size={18} />
            <Link to="/signin">
              <button>Login</button>
            </Link>
          </div>
          <Link to="/signup">
            <Button className="rounded-full px-10">Get Started</Button>
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
